<form class="o-grid o-grid--wrap" [formGroup]="mainForm" name="vm.form" (ngSubmit)="vm.handleFormSubmit(mainForm)" autocomplete="off" novalidate>
	<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up u-no-p" *ngIf="!vm.showOnlyThankYouSection">
		<div class="o-grid o-grid--column">
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
				<section class="c-section c-section--first" panel [isOpen]="vm.isOpen?.service">
					<div class="c-section__header">
						<h1 class="c-section__title c-section__title--sm">{{ 'Booking.Title.Service' | translate }}</h1>
					</div>
					<div class="c-section__content">
						<div class="o-grid">
							<div class="o-grid__cell c-cell u-no-mt">
								<div class="c-card">
									<div class="c-content">
										<div class="o-grid o-grid--wrap o-grid--center-v">
											<div class="o-grid__cell u-no-p">
												<p class="c-text">{{ 'Booking.Prescription.Title' | translate }}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p" *ngIf="vm.booking?.prescriptionRequest">
				<section class="c-section u-no-p" panel>
					<div class="c-section__header u-hidden@md-and-up">
						<h2 class="c-section__title c-section__title--sm">{{ 'Booking.Problem_Description' | translate }}</h2>
					</div>
					<div class="c-section__content">
						<div class="o-grid">
							<div class="o-grid__cell c-cell">
								<div class="c-card">
									<div class="c-content">
										<div class="o-grid u-osb-xs">
											<div class="o-grid__cell o-grid__cell--slim u-no-pl">
												<p class="c-text c-text--gray">{{ 'Booking.Prescription.Name' | translate }}</p>
											</div>
											<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
												<p class="c-text c-text--right c-text--wrap">{{ vm.booking?.prescriptionRequest?.drug?.name || vm.booking?.prescriptionRequest?.drugIngredient?.name }}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
	<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-67@md-and-up u-no-p" *ngIf="!vm.showOnlyThankYouSection">
		<div class="o-grid">
			<div class="o-grid__cell u-no-p">
				<section class="c-section c-section--last"
                 [ngClass]="{ 'c-section--error': vm.submitted && mainForm.invalid }"
                 panel [isOpen]="vm.isOpen?.consents">
					<div class="c-section__header">
						<h2 class="c-section__title c-section__title--sm">{{ 'Booking.Overview' | translate }}</h2>
					</div>
					<div class="c-section__content">
						<div class="o-grid">
							<div class="o-grid__cell u-no-p@up-to-md">
								<div class="c-card" [ngClass]="{ 'c-card--error': vm.submitted && mainForm.invalid }">
									<div class="c-content c-content--lg" *ngIf="vm.booking?.coPay">
										<item-notification icon="attention" [text]="vm.getInsuranceCoPayInfo()" [theme]="5"></item-notification>
									</div>
									<div class="c-content">
										<div class="o-grid o-grid--wrap">
											<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-45@md-and-up u-no-p">
												<div class="o-grid">
													<div class="o-grid__cell u-no-pl">
														<p class="c-text c-text--gray u-no-wrap">{{ 'Booking.Service' | translate }}</p>
													</div>
													<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
														<p class="c-text c-text--right c-text--s2">{{ 'Booking.Prescription.Prescription' | translate }}</p>
													</div>
												</div>
												<div class="o-grid" *ngIf="vm.booking?.date">
													<div class="o-grid__cell u-no-pl">
														<p class="c-text c-text--gray u-no-wrap">{{ 'Booking.Date' | translate }}</p>
													</div>
													<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
														<p class="c-text c-text--right c-text--s2">{{ vm.booking?.date | date: 'dd.MM.yyyy'}}</p>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div class="c-divider c-divider--h@up-to-md u-hidden@md-and-up"></div>
									
									<div class="c-form">
										
										<div class="c-content">
											<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (vm.submitted && mainForm.get('termsCheckbox').invalid) }">
												<label class="c-checkbox">
													<input id="termsCheckbox" formControlName="termsCheckbox" type="checkbox" name="termsCheckbox">
													<span id="termsConsentLabel" [innerHTML]="vm.termsConsent"></span>
												</label>
											</div>
											<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (vm.submitted && mainForm.get('ppCheckbox').invalid) }">
												<label class="c-checkbox">
													<input id="ppCheckbox" formControlName="ppCheckbox" type="checkbox" name="ppCheckbox">
													<span id="ppConsentLabel" [innerHTML]="vm.ppConsent"></span>
												</label>
											</div>
		                                    <div *ngIf="vm.gdprDisclaimerTranslated">
		                                        <item-notification icon="attention" [text]="vm.gdprDisclaimerTranslated" [theme]="5"></item-notification>
		                                    </div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
		<div class="o-grid u-ost-md">
			<div class="o-grid__cell u-hidden@up-to-md"></div>
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-hidden@up-to-md">
				<a id="prescriptionCheckoutBackButton" href="{{vm.booking?.backUrl}}" class="c-button c-button--link c-button--lg">{{ 'Booking.Button.Back' | translate }}</a>
			</div>
			<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right" >
				<button id="prescriptionCheckoutConfirmButton" type="submit" class="c-button c-button--s2 c-button--fit c-button--lg">{{'Modal.Button.Confirm' | translate }}</button>
			</div>
		</div>
	</div>
</form>

<pre-visit-thank-you *ngIf="vm.showOnlyThankYouSection"
	 [isInitialized]="vm.isInitialized"
	 [isRecordTicketForPerson]="vm.isRecordTicketForPerson"
	 [informationSection]="vm.thankYouInformationSection"
	 [preVisitTicketId]="vm.preVisitTicketId">
</pre-visit-thank-you>
